import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const LandingFooter = () => {
  return (
    <footer className="bg-[#0A252D] pt-20 pb-10 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2.5 mb-6">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiIcons.FiLayers} className="text-meetoi-navy text-lg" />
              </div>
              <span className="font-sora text-xl font-bold text-white tracking-tight">Meetoi</span>
            </Link>
            <p className="font-manrope text-meetoi-aqua/60 font-medium leading-relaxed max-w-sm">
              The Relationship Intelligence Platform for modern professionals.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center text-white/70 hover:bg-white/10 hover:text-white transition-colors"><SafeIcon icon={FiIcons.FiLinkedin} size={14} /></a>
              <a href="#" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center text-white/70 hover:bg-white/10 hover:text-white transition-colors"><SafeIcon icon={FiIcons.FiTwitter} size={14} /></a>
              <a href="#" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center text-white/70 hover:bg-white/10 hover:text-white transition-colors"><SafeIcon icon={FiIcons.FiInstagram} size={14} /></a>
            </div>
          </div>
          
          <div>
            <h4 className="font-manrope text-white font-bold mb-6 text-sm">Product</h4>
            <ul className="space-y-4 font-manrope">
              <li><Link to="/#how-it-works" className="text-meetoi-aqua/60 hover:text-white transition-colors text-sm">How it works</Link></li>
              <li><Link to="/#features" className="text-meetoi-aqua/60 hover:text-white transition-colors text-sm">Features</Link></li>
              <li><Link to="/#intelligence" className="text-meetoi-aqua/60 hover:text-white transition-colors text-sm">Intelligence</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-manrope text-white font-bold mb-6 text-sm">Account</h4>
            <ul className="space-y-4 font-manrope">
              <li><Link to="/login" className="text-meetoi-aqua/60 hover:text-white transition-colors text-sm">Log in</Link></li>
              <li><Link to="/register" className="text-meetoi-aqua/60 hover:text-white transition-colors text-sm">Get started</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-manrope text-xs text-meetoi-aqua/40">
            &copy; {new Date().getFullYear()} Meetoi. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};